import Vue from 'vue';
import VueI18n from 'vue-i18n';

import { snakeToArrayOfStrings } from '@/utils/string';

Vue.use(VueI18n);

export const DEFAULT_LOCALE = 'en' as const;

export const i18n = new VueI18n({
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages: {
    en: {},
    es: {},
    fr: {},
    ar: {},
    zh: {},
    zh_HANT: {},
    ko: {},
    ja: {},
    pt: {},
    de: {}
  },
});

function $langCode(this: Vue): string {
  const [code] = snakeToArrayOfStrings(this.$page.props.locale);
  return code;
}

declare module 'vue/types/vue' {
  export interface Vue {
    $langCode: string;
  }
}

Vue.mixin({
  computed: {
    $langCode,
  },
});
